(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["c-card-slider-assets"] && !Shopify.designMode) return;
  try {
    (function() {
    function initSlider(slider) {
      if (slider.dataset.csInit) return;
      

      slider.dataset.csInit = "1";

      var track = slider.querySelector(".c-card-slider__track");
      var btnPrev = slider.querySelector(".c-card-slider__arrow--prev");
      var btnNext = slider.querySelector(".c-card-slider__arrow--next");
      if (! track || ! btnNext) return;
      


      function getScrollAmount() {
        var item = track.querySelector(".c-card-slider__item");
        return item
          ? item.offsetWidth + 12
          : track.clientWidth * 0.8;
      }

      function updateArrows() {
        var scrollLeft = Math.round(track.scrollLeft);
        var maxScroll = Math.round(track.scrollWidth - track.clientWidth);

        if (btnPrev) {
          if (scrollLeft > 4) {
            btnPrev.removeAttribute("hidden");
          } else {
            btnPrev.setAttribute("hidden", "");
          }
        }

        if (scrollLeft >= maxScroll - 4) {
          btnNext.setAttribute("hidden", "");
        } else {
          btnNext.removeAttribute("hidden");
        }
      }

      btnNext.addEventListener("click", function() {
        track.scrollBy({left: getScrollAmount(), behavior: "smooth"});
      });

      if (btnPrev) {
        btnPrev.addEventListener("click", function() {
          track.scrollBy({
            left: - getScrollAmount(),
            behavior: "smooth"
          });
        });
      }

      track.addEventListener("scroll", updateArrows, {passive: true});
      updateArrows();
    }

    function init(root) {
      (root || document).querySelectorAll(".c-card-slider").forEach(initSlider);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function() {
        init();
      });
    } else {
      init();
    }

    document.addEventListener("shopify:section:load", function(e) {
      init(e.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
